module.exports = __webpack_public_path__ + "img/06d473a1ec7d9b58db6e85398c6c6706.png";